import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Leaf, Anchor, Sun } from 'lucide-react';
export function MethodSection() {
  return <section className="w-full px-6 py-24 bg-sage/10" data-id="element-43">
      <div className="max-w-2xl mx-auto" data-id="element-44">
        <AnimatedSection className="text-center mb-16" data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-46">
            Lo que hace diferente a <br data-id="element-47" />
            <span className="italic text-terracotta" data-id="element-48">Duelo Libre 40+</span>
          </h2>
          <p className="text-lg text-charcoal/80" data-id="element-49">
            Esto no es un libro para "entender" el duelo. <br data-id="element-50" />
            Es un protocolo para administrarlo. Se llama <strong data-id="element-51">TR3</strong>.
          </p>
        </AnimatedSection>

        <div className="space-y-12" data-id="element-52">
          {/* Phase 1 */}
          <AnimatedSection delay={0.1} className="flex flex-col md:flex-row gap-6 items-start" data-id="element-53">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-terracotta/10 flex items-center justify-center text-terracotta" data-id="element-54">
              <Anchor size={24} data-id="element-55" />
            </div>
            <div data-id="element-56">
              <h3 className="text-2xl font-serif text-charcoal mb-2" data-id="element-57">
                1. TIERRA{' '}
                <span className="text-base font-sans text-charcoal/50 ml-2" data-id="element-58">
                  (Días 1–10)
                </span>
              </h3>
              <p className="text-lg text-charcoal/80 mb-2" data-id="element-59">
                Regulas el cuerpo y el entorno para salir del modo alarma.
              </p>
              <p className="text-base text-charcoal/60 italic" data-id="element-60">
                Porque una mujer en alarma toma decisiones que luego paga.
              </p>
            </div>
          </AnimatedSection>

          {/* Phase 2 */}
          <AnimatedSection delay={0.2} className="flex flex-col md:flex-row gap-6 items-start" data-id="element-61">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage/20 flex items-center justify-center text-sage" data-id="element-62">
              <Leaf size={24} data-id="element-63" />
            </div>
            <div data-id="element-64">
              <h3 className="text-2xl font-serif text-charcoal mb-2" data-id="element-65">
                2. RITUAL{' '}
                <span className="text-base font-sans text-charcoal/50 ml-2" data-id="element-66">
                  (Días 11–20)
                </span>
              </h3>
              <p className="text-lg text-charcoal/80 mb-2" data-id="element-67">
                Cierras micro-duelos: rutina, futuro, rol, narrativa.
              </p>
              <p className="text-base text-charcoal/60 italic" data-id="element-68">
                Porque tu mente no deja de pensar… cuando no hay cierres.
              </p>
            </div>
          </AnimatedSection>

          {/* Phase 3 */}
          <AnimatedSection delay={0.3} className="flex flex-col md:flex-row gap-6 items-start" data-id="element-69">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-stone flex items-center justify-center text-charcoal" data-id="element-70">
              <Sun size={24} data-id="element-71" />
            </div>
            <div data-id="element-72">
              <h3 className="text-2xl font-serif text-charcoal mb-2" data-id="element-73">
                3. RECLAMACIÓN{' '}
                <span className="text-base font-sans text-charcoal/50 ml-2" data-id="element-74">
                  (Días 21–30)
                </span>
              </h3>
              <p className="text-lg text-charcoal/80 mb-2" data-id="element-75">
                Construyes identidad con evidencia: límites, hábitos,
                decisiones.
              </p>
              <p className="text-base text-charcoal/60 italic" data-id="element-76">
                Porque la libertad no es un sentimiento. Es una práctica.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}